import { render, staticRenderFns } from "./LoginTransfer.vue?vue&type=template&id=4f2bbfec"
import script from "./LoginTransfer.vue?vue&type=script&lang=js"
export * from "./LoginTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports